import { render, staticRenderFns } from "./ListAndCard.vue?vue&type=template&id=0eff4295"
import script from "./ListAndCard.vue?vue&type=script&lang=js"
export * from "./ListAndCard.vue?vue&type=script&lang=js"
import style0 from "./ListAndCard.vue?vue&type=style&index=0&id=0eff4295&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports